module.exports = __webpack_public_path__ + "static/media/new-york-36.2224bee4.jpg";